import { z } from "zod";

import { ROLES_AS_ARRAY } from "@/constants/admin";
import {
  testPasswordContainsLowercaseLetter,
  testPasswordContainsNumber,
  testPasswordContainsSpecialCharacter,
  testPasswordContainsUppercaseLetter,
} from "@/utils";

export const adminSchema = z.object({
  id: z.number(),
  name: z.string(),
  email: z.string(),
  role: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const adminListItemSchema = adminSchema.extend({
  hasValidPassword: z.boolean(),
  passwordExpiresAt: z.string().nullable(),
});

export const passwordFieldSchema = z
  .string()
  .min(8, { message: "The password is too short" })
  .refine(
    (password) => {
      return testPasswordContainsUppercaseLetter(password);
    },
    {
      message: "The password must contain a capital letter",
    },
  )
  .refine(
    (password) => {
      return testPasswordContainsLowercaseLetter(password);
    },
    {
      message: "The password must contain a lowercase letter",
    },
  )
  .refine(
    (password) => {
      return testPasswordContainsNumber(password);
    },
    {
      message: "The password must contain a number",
    },
  )
  .refine(
    (password) => {
      return testPasswordContainsSpecialCharacter(password);
    },
    {
      message: "The password must contain a special character",
    },
  );

export const editAdminSchema = z
  .object({
    email: z.string().email(),
    name: z.string(),
    role: z.enum(ROLES_AS_ARRAY),
    password: passwordFieldSchema.optional(),
    passwordConfirmation: z.string().optional(),
  })
  .superRefine(({ password, passwordConfirmation }, ctx) => {
    if (password !== passwordConfirmation) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Passwords do not match",
        path: ["passwordConfirmation"],
      });
    }
  });

export const choosePasswordSchema = z
  .object({
    password: passwordFieldSchema,
    passwordConfirmation: z.string().min(1, {
      message: "The password confirmation field is required.",
    }),
  })
  .superRefine(({ password, passwordConfirmation }, ctx) => {
    if (password !== passwordConfirmation) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Passwords do not match",
        path: ["passwordConfirmation"],
      });
    }
  });
